document.addEventListener('DOMContentLoaded', () => {
	// --- Mobile Menu Logic ---
	const openButton = document.getElementById('mobile-menu-open-button')
	const closeButton = document.getElementById('mobile-menu-close-button')
	const mobileMenu = document.getElementById('mobile-menu')

	if (openButton && closeButton && mobileMenu) {
		openButton.addEventListener('click', () => {
			mobileMenu.classList.remove('hidden')
		})

		closeButton.addEventListener('click', () => {
			mobileMenu.classList.add('hidden')
		})
	}

	// --- Mobile Menu Slide-Down Logic ---
	const menuButton = document.getElementById('mobile-menu-button')
	const navPanel = document.getElementById('mobile-nav-panel')

	if (menuButton && navPanel) {
		menuButton.addEventListener('click', (e) => {
			e.stopPropagation()
			navPanel.classList.toggle('open')
			menuButton.classList.toggle('open')
		})

		window.addEventListener('click', (e) => {
			// If the menu is open AND the click was NOT on the panel itself...
			if (navPanel.classList.contains('open') && !navPanel.contains(e.target)) {
				menuButton.classList.remove('open')
				navPanel.classList.remove('open')
			}
		})
	}

	// --- Submenu Accordion Logic ---
	const subMenuContainer = document
		.querySelector('#mobile-nav-panel')
		.querySelector('.submenu-container')
	const subMenuContent = subMenuContainer.querySelector('.submenu-content')
	const arrowButton = subMenuContainer.querySelector('.button-arrow')
	const arrow = subMenuContainer.querySelector('.submenu-arrow')
	// Toggle trạng thái
	arrowButton.addEventListener('click', () => {
		if (
			subMenuContent.style.maxHeight &&
      subMenuContent.style.maxHeight !== '0px'
		) {
			subMenuContent.style.maxHeight = '0px'
			arrow.classList.remove('rotate-180')
		} else {
			subMenuContent.style.maxHeight = subMenuContent.scrollHeight + 'px'
			arrow.classList.add('rotate-180')
		}
	})
})
